import React from 'react'

interface GoogleMapsEmbedProps {
  embedUrl: string
  height?: number
  title?: string
  loading?: 'lazy' | 'eager'
}

/**
 * Google Maps Embed Component
 *
 * Displays an embedded Google Maps iframe for Ada Aesthetics clinic location
 *
 * Contract: FR-010 - Embed Google Maps on service pages
 * Performance: Uses lazy loading by default for LCP optimization
 */
const GoogleMapsEmbed: React.FC<GoogleMapsEmbedProps> = ({
  embedUrl,
  height = 400,
  title = 'Ada Aesthetics Clinic Location',
  loading = 'lazy',
}) => {
  return (
    <section aria-label="Location" className="google-maps-embed" style={{ marginBottom: '2rem' }}>
      <iframe
        src={embedUrl}
        width="100%"
        height={height}
        style={{ border: 0 }}
        allowFullScreen
        loading={loading}
        title={title}
        referrerPolicy="no-referrer-when-downgrade"
      />
    </section>
  )
}

export default GoogleMapsEmbed
